import { MyActivityInitialState } from "../../../types/sales/myActivityInterface";
import { ActivityActionTypes, ActivityActions } from "../../actionTypes/sales/activityActionTypes";

const initialState: MyActivityInitialState = {
  myActivityList: [],
  myActivityListPageCount: 0,
  myActivityData: {
    id: 0,
    title: "",
    target_name: null,
    target_type: "",
    activity_logs: null,
    target_code: "",
    assigned_to: 0,
    event_type: "",
    event_date: undefined,
    location: "",
    agenda: "",
    activity_status: "",
    cancel_reason: "",
    created_by: 0,
    customer_id: null,
    lead_id: null,
    createdAt: undefined,
    lead: null,
    customer: {
      id: 0,
      customer_code: "",
      company_name: "",
      contact_person: "",
      contact_person_designation: "",
      contact_number: "",
      parent_customer_id: 0,
      email: "",
      company_id: 0,
      is_gst_applicable: 0,
      gstin: "",
      gst_rate: 0,
      pan_card_no: "",
      mis_email: "",
      billing_email: "",
      operation_email: "",
      api_access: 0,
      sac_code: "",
      credit_days: 0,
      credit_limit: 0,
      address: "",
      pincode: 0,
      assigned_customer_support: 0,
      assigned_customer_support_alt: null,
      assigned_operation_person: 0,
      assigned_operation_person_alt: null,
      assigned_sales_person: 0,
      assigned_sales_person_alt: null,
      createdAt: undefined,
      updatedAt: undefined,
      lead_id: 0,
      pre_lead_id: 0,
      pincode_data: {
        id: 0,
        pincode: 0,
        district: {
          district_name: "",
          state: {
            state_name: "",
          },
        },
      },
    },
  },
};

export default function myActivityReducer(state = initialState, action: ActivityActionTypes): MyActivityInitialState {
  switch (action.type) {
    case ActivityActions.SET_MY_ACTIVITY_LIST:
      return {
        ...state,
        myActivityList: action.payload,
      };

    case ActivityActions.SET_MY_ACTIVITY_LIST_PAGE_COUNT:
      return {
        ...state,
        myActivityListPageCount: action.payload,
      };

    case ActivityActions.SET_MY_ACTIVITY_DATA:
      return {
        ...state,
        myActivityData: action.payload,
      };

    default:
      return state;
  }
}
